window.addEventListener('load', () => {
    const resizeDelay = 240;
    let resizeTimeout;

    window.addEventListener("resize", () => {
        /* update all frame containers and use the same timer */
        document.querySelectorAll('.fb_iframe_widget').forEach((iframeContainer) => {
            handleResize(iframeContainer);
        });
    });

    function handleResize(iframeContainer) {
        /* debounce update frame with a global timeout */
        try {
            iframeContainer.style.transition = `opacity 0.3s ease-in-out`;
            iframeContainer.style.opacity = 0;

            clearTimeout(resizeTimeout);

            resizeTimeout = setTimeout(() => {
                updateIframe(iframeContainer);
            }, resizeDelay);
        } catch (error) { }
    }

    /**
     * @param {HTMLElement} iframeContainer
     */
    function updateIframe(iframeContainer) {
        const spanWrapper = iframeContainer.querySelector('span');
        const iframe = iframeContainer.querySelector('iframe');

        iframeContainer.style.width = '100%';
        spanWrapper.style.width = '100%';
        iframe.style.width = '100%';

        const computedWidth = window.getComputedStyle(spanWrapper).getPropertyValue('width');
        const iframeSrc = iframe.src;

        spanWrapper.style.width = computedWidth;

        const searchParams = new URLSearchParams(iframeSrc.split('?')[1]);

        /* set query width to max parent width */
        searchParams.set('width', Math.trunc(computedWidth.replace('px', '')));

        /* disable adapt to allow the iframe to be bigger than the original one */
        searchParams.set('adapt_container_width', false);

        iframe.src = iframeSrc.split('?')[0] + '?' + searchParams.toString();

        iframe.addEventListener('load', () => {
            iframeContainer.style.opacity = 1;
        }, { once: true });
    }
});